import { searchPerson as fetchPersons } from 'ntnu-react/util/sp';
import { getAvatarUrlByEmail } from 'ntnu-react/util/sp';

export function filterPersons(input) {
    return input.map((item) => {
        return {
            key: item.EntityData && item.EntityData.Email || item.Key,
            text: item.DisplayText,
            avatar: getAvatarUrlByEmail(item.EntityData && item.EntityData.Email || item.Key),
        };
    });
}

export function searchPerson(text) {
    if (__DEV__) {
        const people = require('../mock/people.json');
        return Promise.resolve(people);
    }
    return fetchPersons(text).then(filterPersons);
}



// WEBPACK FOOTER //
// ./src/utils/index.js